import React from 'react'
import { PageWrapper } from '@/components/__UI'
import PriceRecommendations from '../../components/__PriceRecommendations/PriceRecommendations/PriceRecommendations'
import AllSet from '../../components/__PriceRecommendations/AllSet/AllSet'
import { useTranslation } from 'react-i18next'
import { PriceContainer } from './PriceRecommendationsPage.styles'
import { useUser } from '@/context/UserProvider'
import { useQueryPropertyPricingSummary } from '@/hooks/useQuery'

const PriceRecommendationsPage = () => {
    const { t } = useTranslation()
    const { user } = useUser()
    const { data, isLoading, isError } = useQueryPropertyPricingSummary()

    if (data != null && !data.showPricingRecommendations) {
        return <AllSet></AllSet>
    }

    let title = t(
        `newSeasonPricingProposal_${user.attributes.brand}`,
        t('newSeasonPricingProposal')
    )

    if (data == null && isLoading) {
        title = undefined
    }

    return (
        <PageWrapper title={title}>
            <PriceContainer>
                <PriceRecommendations
                    data={data}
                    isLoading={isLoading}
                    isError={isError}
                />
            </PriceContainer>
        </PageWrapper>
    )
}

export default PriceRecommendationsPage
